export const TaskTitleTypes = [
    {
        Key: "Other",
        Value: 1,
    },
    {
        Key: "Lead Call",
        Value: 2,
    },
    {
        Key: "Parcel",
        Value: 3,
    },
    {
        Key: "Appointment",
        Value: 4,
    },
    {
        Key: "Making",
        Value: 5,
    },
    {
        Key: "Customer Attend",
        Value: 6,
    },
    {
        Key: "Lead Search",
        Value: 7,
    },
    {
        Key: "DC Figure",
        Value: 8,
    },
    {
        Key: "Fabric Order",
        Value: 9,
    },
    {
        Key: "Fabric Purchase",
        Value: 10,
    },
    {
        Key: "Un-Bill Create",
        Value: 11,
    },
    {
        Key: "Un-Bill Show",
        Value: 12,
    },
    {
        Key: "Purchase",
        Value: 13,
    },
    {
        Key: "Designer",
        Value: 14,
    },
    {
        Key: "Work Manager",
        Value: 15,
    },
    {
        Key: "Sales Person",
        Value: 16,
    },
    {
        Key: "Stitching Person",
        Value: 17,
    },
    {
        Key: "Draw Order",
        Value: 18,
    },
    {
        Key: "Draw Delivered",
        Value: 19,
    },
    {
        Key: "Cutting Order",
        Value: 20,
    },
    {
        Key: "Cutting Delivered",
        Value: 21,
    },
]

export function GetObjByTaskTitleTypes(...values) {
    const array = [
        {
            Key: "Other",
            Value: 1,
        },
        {
            Key: "Lead Call",
            Value: 2,
        },
        {
            Key: "Parcel",
            Value: 3,
        },
        {
            Key: "Appointment",
            Value: 4,
        },
        {
            Key: "Making",
            Value: 5,
        },
        {
            Key: "Customer Attend",
            Value: 6,
        },
        {
            Key: "Lead Search",
            Value: 7,
        },
        {
            Key: "DC Figure",
            Value: 8,
        },
        {
            Key: "Fabric Order",
            Value: 9,
        },
        {
            Key: "Fabric Purchase",
            Value: 10,
        },
        {
            Key: "Un-Bill Create",
            Value: 11,
        },
        {
            Key: "Un-Bill Show",
            Value: 12,
        },
        {
            Key: "Purchase",
            Value: 13,
        },
        {
            Key: "Designer",
            Value: 14,
        },
        {
            Key: "Work Manager",
            Value: 15,
        },
        {
            Key: "Sales Person",
            Value: 16,
        },
        {
            Key: "Stitching Person",
            Value: 17,
        },
        {
            Key: "Draw Order",
            Value: 18,
        },
        {
            Key: "Draw Delivered",
            Value: 19,
        },
    ]
    return array.filter(obj => values.includes(obj.Value));
}

export function GetObjByTaskStatus(...values) {
    const array = [
        {
            Key: "Select Status",
            Value: 0,
        },
        {
            Key: "Assigned",
            Value: 1,
        },
        {
            Key: "In-Progress",
            Value: 2,
        },
        {
            Key: "Done",
            Value: 3,
        },
        {
            Key: "Discard",
            Value: 4,
        },
    ]
    return array.filter(obj => values.includes(obj.Value));
}

export const UnBillsType = [
    {
        Key: "Rent",
        Value: 1,
    },
    {
        Key: "Making",
        Value: 2,
    },
]

export const UnBillsRentMakingStatus = [
    {
        Key: "Created",
        Value: 1,
    },
    {
        Key: "Convert",
        Value: 2,
    },
    {
        Key: "Fail",
        Value: 3,
    },
]

export function GetObjByUnBillsRentMakingStatus(...values) {
    const array = [
        {
            Key: "Created",
            Value: 1,
        },
        {
            Key: "Convert",
            Value: 2,
        },
        {
            Key: "Fail",
            Value: 3,
        },
    ]
    return array.filter(obj => values.includes(obj.Value));
}

export const WeddingData = [["OWN", 1], ["SIBLING", 2], ["FRIEND / COUSIN", 3], ["FESTIVE", 4], ["OTHER", 5]]

export const MsgColors = [
    {
        Key: "Msg1",
        Value: "#D7EDD5"
    },
    {
        Key: "Msg2",
        Value: "#50a5f140"
    },
    {
        Key: "Msg3",
        Value: "#f1b44c40"
    },
    {
        Key: "Msg4",
        Value: "#556ee61a"
    },
    {
        Key: "Msg5",
        Value: "#FFE1E0"
    },
    {
        Key: "Msg6",
        Value: "#74788d40"
    },
    {
        Key: "Msg7",
        Value: "#556ee640"
    },
    {
        Key: "Msg8",
        Value: "#E4EFE7"
    },
    {
        Key: "Msg9",
        Value: "#FFDDAE"
    },
    {
        Key: "Msg10",
        Value: "#F9F5F6"
    },
]

export function GetObjByMsgColor(...values) {
    const array = [
        {
            Value: 1,
            Key: "Msg1",
            Color: "#D7EDD5"
        },
        {
            Value: 2,
            Key: "Msg2",
            Color: "#50a5f140"
        },
        {
            Value: 3,
            Key: "Msg3",
            Color: "#f1b44c40"
        },
        {
            Value: 4,
            Key: "Msg4",
            Color: "#556ee61a"
        },
        {
            Value: 5,
            Key: "Msg5",
            Color: "#FFE1E0"
        },
        {
            Value: 6,
            Key: "Msg6",
            Color: "#74788d40"
        },
        {
            Value: 7,
            Key: "Msg7",
            Color: "#556ee640"
        },
        {
            Value: 8,
            Key: "Msg8",
            Color: "#E4EFE7"
        },
        {
            Value: 9,
            Key: "Msg9",
            Color: "#FFDDAE"
        },
        {
            Value: 10,
            Key: "Msg10",
            Color: "#F9F5F6"
        },
    ]
    return array.filter(obj => values.includes(obj.Value));
}

export function GetObjByPaymentMode(...values) {
    const array = [
        {
            Key: "Cash",
            Value: 1,
        },
        {
            Key: "Bank",
            Value: 2,
        },
    ]
    return array.filter(obj => values.includes(obj.Value));
}
// export const TaskStatus = [
//     {
//         Key: "Select Status",
//         Value: 0,
//     },
//     {
//         Key: "Assigned",
//         Value: 1,
//     },
//     {
//         Key: "In-Progress",
//         Value: 2,
//     },
//     {
//         Key: "Done",
//         Value: 3,
//     },
//     {
//         Key: "Discard",
//         Value: 4,
//     },
// ]

export function GetObjByPaymentModeType(...values) {
    const array = [
        {
            Key: "N/A",
            Value: 0,
        },
        {
            Key: "Cash",
            Value: 1,
        },
        {
            Key: "PVT. LTD.",
            Value: 2,
        },
        {
            Key: "Kiara",
            Value: 3,
        },
    ]
    return array.filter(obj => values.includes(obj.Value));
}

export const HandWorkCostingStatus = [
    {
        Key: "Hand Work Created",
        Value: 1,
    },
    {
        Key: "In-Progress",
        Value: 2,
    },
    {
        Key: "Standby",
        Value: 3,
    },
    {
        Key: "Stitching",
        Value: 4,
    },
    {
        Key: "Completed",
        Value: 5,
    },
]

export function GetObjByHandWorkCostingStatus(...values) {
    const array = [
        {
            Key: "Hand Work Created",
            Value: 1,
        },
        {
            Key: "In-Progress",
            Value: 2,
        },
        {
            Key: "Standby",
            Value: 3,
        },
        {
            Key: "Stitching",
            Value: 4,
        },
        {
            Key: "Completed",
            Value: 5,
        },
    ]
    return array.filter(obj => values.includes(obj.Value));
}

export const HandWorkOrderStatus = [
    {
        Key: "Order Created",
        Value: 1,
    },
    {
        Key: "Assign to Designer",
        Value: 2,
    },
    {
        Key: "Hand Work",
        Value: 3,
    },
    {
        Key: "Stitching",
        Value: 4,
    },
    {
        Key: "Completed",
        Value: 5,
    },
]

export function GetObjByHandWorkOrderStatus(...values) {
    const array = [
        {
            Key: "Order Created",
            Value: 1,
        },
        {
            Key: "Assign to Designer",
            Value: 2,
        },
        {
            Key: "Hand Work",
            Value: 3,
        },
        {
            Key: "Stitching",
            Value: 4,
        },
        {
            Key: "Completed",
            Value: 5,
        },
    ]
    return array.filter(obj => values.includes(obj.Value));
}

export function GetObjByEmployeeLeaveStatus(...values) {
    const array = [
        {
            Key: "Rquested",
            Value: 1,
        },
        {
            Key: "Approved",
            Value: 2,
        },
        {
            Key: "Rejected",
            Value: 3,
        },
    ]
    return array.filter(obj => values.includes(obj.Value));
}
export function GetObjByAttendanceUserRoles(...values) {
    const array = [
        {
            Key: "User",
            Value: 1,
        },
        {
            Key: "Stitching Worker",
            Value: 2,
        },
        {
            Key: "Stitching Master",
            Value: 3,
        },
        {
            Key: "Worker",
            Value: 4,
        },
    ]
    return array.filter(obj => values.includes(obj.Value));
}